<template>
  <ion-page>
    <CabeceraComponent
      :pdv="pdv"
      :isIOS="isIOS"
      titulo="Inventarios"
      color="primary"
    />

    <ion-content>

      <!-- FAB filtros por fecha -->
      <ion-fab vertical="top" horizontal="end" slot="fixed">
        <ion-fab-button color="primary" @click="abrirModalDeFiltros()" v-if="numSelectedItems === 0">
          <i class="fas fa-sharp fa-filter en-fab"></i>
        </ion-fab-button>
        <ion-fab-button color="danger" @click="abrirModalDeFiltros()" v-else>
          <ion-badge id="num-selected-items" color="primary">{{ numSelectedItems }}</ion-badge>
          <i class="fas fa-sharp fa-filter en-fab icon-filter"></i>
        </ion-fab-button>
      </ion-fab>

      <div class="container-tablet">
      
        <!-- Resumen de estados y contador -->
        <div v-if="resumenes && resumenes.length > 0" class="pickings-counter-sticky">
          <ion-button expand="block" fill="outline" size="large" class="trigger_scan">
            <ion-title>
              <ion-text class="ion-text-wrap estrecho">
                <b>{{ resumenes.length }} inventarios</b>
              </ion-text>
            </ion-title>
          </ion-button>
        </div>
        
        <!-- Spinner de carga mientras preparamos la vista -->
        <ion-row class="spin ion-justify-content-center" v-if="!showme">
          <ion-col v-if="!showme" class="spin ion-align-self-center" size="48">
            <ion-spinner v-if="!showme"></ion-spinner>
          </ion-col>
        </ion-row>

        <!-- listado de inventarios por fecha con estado resumido -->
        <ion-list style="margin: 0;">
          <ion-item-sliding v-for="it in resumenes_filtrados" :key="`${it.fecinv}-${it.clasif}`">
            <ion-item :button="puedeAbrirResumen(it) && loadingEnvioSapKey !== resumenKey(it)" :detail="loadingEnvioSapKey !== resumenKey(it) && puedeAbrirResumen(it)" @click="goDetalleResumen(it)">
              <ion-spinner v-if="loadingEnvioSapKey === resumenKey(it)" slot="end" color="primary"></ion-spinner>
              <ion-row>
                <ion-col size="32" class="ion-align-self-center">
                  <p class="titulo">{{ this.$filters.formatNum2Date(it.fecinv) }} <span class="lote oscuro">({{ it.clasif }})</span></p>
                  <div class="lote oscuro">
                    {{ it.ubicaciones || 0 }} Ubicaciones<br />
                  </div>
                  <div class="lote oscuro">
                    {{ it.articulos || 0 }} Articulos<br />
                  </div>
                </ion-col>
                <ion-col size="16" class="ion-align-self-center">
                  <InventarioEstadoRatio :v1="valorEstado(it)" :v2="it.lineas || 0" :estado="estadoTexto(it)" />
                </ion-col>
              </ion-row>
            </ion-item>
            <ion-item-options side="start" v-if="Number(ubiku_rol) >= 10">
              <ion-item-option color="primary" @click="verDiferencias(it)">
                <ion-icon slot="bottom" class="muy-grande" :icon="eyeOutline"></ion-icon>
                <span class="boton-opciones">Ver diferencias</span>
              </ion-item-option>
            </ion-item-options>
            <ion-item-options side="end" v-if="Number(ubiku_rol) >= 10">
              <ion-item-option color="tertiary" v-if="estadoTexto(it) === inventario_estados.aprobado.texto" :disabled="loadingEnvioSap" @click="enviarInventarioSap(it)">
                <ion-icon slot="bottom" class="muy-grande" :icon="sendOutline"></ion-icon>
                <span class="boton-opciones">Aceptar y cerrar</span>
              </ion-item-option>
            </ion-item-options>
          </ion-item-sliding>
        </ion-list>
      </div>

      <!-- si no hay inventarios visibles (base o filtrados), informamos al usuario -->
      <div v-if="resumenes_filtrados && resumenes_filtrados.length === 0 && showme" style="display: flex; flex: 1 1 auto; height: 100%;" class="ion-justify-content-center">
        <!-- Hacer un aviso sin ion-card, solo texto con un header y un body -->
        <div class="ion-align-self-center">
          <h2>Sin datos en este segmento</h2>
          <p>Sin datos para la fecha seleccionada o filtros aplicados.</p>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import { defineComponent } from 'vue'
import CabeceraComponent from '@/components/CabeceraComponent.vue'
import InventarioEstadoRatio from '@/components/InventarioEstadoRatio.vue'
import eventBus from '@/event-bus'
import { openToast, openAlertaBinaria } from '@/utilities/services/alert-utilities'
import { modalController } from '@ionic/vue'
import ModalFiltros from '@/components/ModalFiltros.vue'
import { inventario_estados } from '@/utilities/global-constants'
import { loadStorage } from '@/utilities/storage/storage-utilities-main'
import { sendOutline, eyeOutline } from 'ionicons/icons'

export default defineComponent({
  name: 'MainInventarios',
  components: { CabeceraComponent, InventarioEstadoRatio },
  data () {
    return {
      pdv: this.$route.meta.pdv,
      isIOS: this.$route.meta.isIOS,
      ubiku_rol: this.$route.meta.racrol,
      showme: false,
      resumenes: [],
      filtros: [],
      numSelectedItems: 0,
      inventarios_filtrados: [],
      filtro_estado: '',
      loadingEnvioSap: false,
      loadingEnvioSapKey: null,
      esPdvSap: true,
      inventario_estados,
      sendOutline,
      eyeOutline
    }
  },
  created () {
    // Recuperamos datos comunes desde meta y mostramos el spinner de transición
    this.pdv = this.$route.meta.pdv
    this.isIOS = this.$route.meta.isIOS
    this.ubiku_rol = this.$route.meta.racrol
  },
  async mounted () {
    this.$NoBackNavigator()
    eventBus().emitter.once('transicion', () => (this.showme = false))
    this.showme = false
    await this.cargaTipoPdv()
    await this.cargaInventarios()
    this.showme = true
  },
  methods: {
    async cargaTipoPdv () {
      // los PDVs de Gestion 2000 (no SAP) cierran el inventario solo en Ubiku
      try {
        const pdvsSap = await loadStorage('pdvsSap') || []
        this.esPdvSap = pdvsSap.length === 0 || pdvsSap.indexOf(this.pdv) !== -1
      } catch (ex) {
        this.esPdvSap = true
      }
    },
    resumenKey (it) {
      if (!it) return ''
      return `${it.fecinv}-${it.clasif || '00'}`
    },
    async cargaInventarios () {
      // cargamos el resumen de inventarios del PDV desde backend
      try {
        const url = `/inventario_resumen/${this.pdv}`
        const res = await this.$http.get(url)
        const arr = Array.isArray(res.data) ? res.data : []
        // Normalizamos los campos para evitar valores undefined y ordenamos por fecha descendente
        this.resumenes = arr
          .map(v => ({
            fecinv: String(v.fecinv || v.fecha || ''),
            clasif: String(v.clasif || '00'),
            lineas: Number(v.lineas || 0),
            articulos: Number(v.articulos || 0),
            pendientes: Number(v.pendientes || 0),
            reabiertos: Number(v.reabiertos || 0),
            aprobados: Number(v.aprobados || 0),
            cerrados: Number(v.cerrados || 0),
            ubicaciones: Number(v.ubicaciones || 0),
            estado: String(v.estado || '').toUpperCase()
          }))
          .filter(v => v.fecinv)
          .sort((a, b) => (a.fecinv < b.fecinv ? 1 : a.fecinv > b.fecinv ? -1 : 0))
        // reiniciamos filtros basados en nuevas fechas
        this.inventarios_filtrados = []
        this.generarFiltrosFechas()
      } catch (ex) {
        // notificamos error de backend de manera visible para el usuario
        openToast('Error cargando inventarios del PDV')
        console.log(ex)
        this.resumenes = []
      }
    },
    verDiferencias (it) {
      if (!it || !it.fecinv) return
      this.$router.push({ name: 'inventario_diferencias', params: { pdv: this.pdv, fecinv: it.fecinv, clasif: it.clasif || '00' } })
    },
    generarFiltrosFechas () {
      // genera el filtro único de fechas de inventario
      const fechas = [...new Set(this.resumenes.map(r => r.fecinv))]
      this.filtros = [
        { filterName: 'Fecha de inventario', items: fechas, filteredItems: fechas, selectedItems: [] }
      ]
      this.numSelectedItems = 0
    },
    async abrirModalDeFiltros () {
      // reusamos ModalFiltros para seleccionar fechas de inventario
      const modal = await modalController.create({
        component: ModalFiltros,
        componentProps: {
          filters: this.filtros,
          datos: this.resumenes,
          datosFiltrados: this.inventarios_filtrados,
          rutas: [],
          datosFiltradosConRuta: []
        }
      })
      await modal.present()
      const { data, role } = await modal.onWillDismiss()
      if (role === 'clean') {
        this.generarFiltrosFechas()
        this.inventarios_filtrados = []
        return
      }
      if (role === 'confirm') {
        this.filtros = data[0]
        this.numSelectedItems = this.filtros.flatMap(f => f.selectedItems).length
        this.inventarios_filtrados = data[1]
      }
    },
    goDetalleResumen (it) {
      // navegamos al detalle del inventario seleccionado
      if (!it || !it.fecinv) return
      // Ahora navegamos usando la ruta nombrada y params en el path
      this.$router.push({ name: 'inventario_detalle', params: { pdv: this.pdv, fecinv: it.fecinv, clasif: it.clasif || '00' } })
    },
    aplicarFiltroEstado (estado) {
      // filtro desde el widget de resumen
      this.filtro_estado = estado || ''
    },
    valorEstado (it) {
      const e = this.estadoTexto(it)
      if (e === inventario_estados.aprobado.texto) return Number(it.aprobados || 0)
      if (e === inventario_estados.reabierto.texto) return Number(it.reabiertos || 0)
      if (e === inventario_estados.cerrado.texto) return Number(it.cerrados || 0)
      return Number(it.pendientes || 0)
    },
    estadoColorClase (it) {
      // priorizamos el estado explícito si existe; si no, calculamos por contadores
      const est = String(it.estado || '').toUpperCase()
      if (est === inventario_estados.cerrado.db) return 'fracaso'
      if (est === inventario_estados.aprobado.db) return 'exito'
      if (est === inventario_estados.reabierto.db) return 'aviso'
      if (est === inventario_estados.pendientes.db) return 'oscuro'
      // fallback
      if (it.cerrados > 0 && it.cerrados >= it.lineas) return 'fracaso'
      if (it.pendientes === 0 && it.reabiertos >= it.lineas && it.aprobados === it.lineas) return 'exito'
      if (it.pendientes === 0 && it.reabiertos > 0 && it.aprobados < it.reabiertos) return 'aviso'
      return 'oscuro'
    },
    estadoTexto (it) {
      // priorizamos el estado explícito si viene del backend
      const est = String(it.estado || '').toUpperCase()
      if (est === inventario_estados.aprobado.db) return inventario_estados.aprobado.texto
      if (est === inventario_estados.reabierto.db) return inventario_estados.reabierto.texto
      if (est === inventario_estados.cerrado.db) return inventario_estados.cerrado.texto
      if (est === inventario_estados.pendientes.db) return inventario_estados.pendientes.texto
      // fallback por contadores cuando no hay estado consolidado
      if (it.cerrados > 0 && it.cerrados >= it.lineas) return inventario_estados.cerrado.texto
      if (it.pendientes === 0 && it.reabiertos > 0 && it.aprobados < it.reabiertos) return inventario_estados.reabierto.texto
      if (it.pendientes === 0 && it.reabiertos >= it.lineas) return inventario_estados.aprobado.texto
      return inventario_estados.pendientes.texto
    },
    puedeAbrirResumen (it) {
      const esGerente = Number(this.ubiku_rol) >= 10
      const est = this.estadoTexto(it)
      return esGerente || est === inventario_estados.pendientes.texto || est === inventario_estados.reabierto.texto
    },
    async enviarInventarioSap (it) {
      if (!it || !it.fecinv) return
      if (this.loadingEnvioSap) return
      const key = this.resumenKey(it)
      try {
        if (Number(this.ubiku_rol) < 10) {
          openToast(this.esPdvSap ? 'Solo el gerente puede enviar a SAP' : 'Solo el gerente puede cerrar el inventario')
          return
        }
        const ok = this.esPdvSap
          ? await openAlertaBinaria(
            'Enviar inventario a SAP',
            'Si envías a SAP, se cerrará el inventario, no se podrá deshacer el envío y no se podrá reabrir para actualizar.',
            'Cancelar',
            'Enviar a SAP'
          )
          : await openAlertaBinaria(
            'Cerrar inventario',
            'Si cierras el inventario, no se podrá deshacer el cierre y no se podrá reabrir para actualizar.',
            'Cancelar',
            'Cerrar inventario'
          )
        if (!ok) return

        this.loadingEnvioSap = true
        this.loadingEnvioSapKey = key
        const res = await this.$http.post(`/inventario_enviar_sap/${this.pdv}`, { fecinv: it.fecinv, clasif: it.clasif || '00', ubiku_rol: Number(this.ubiku_rol) })
        // Validación de respuesta del backend (homogeneización de errores)
        const data = (res && res.data) || {}
        if (Object.keys(data).length === 0 || data.status === 0 || data.error) {
          throw { response: { data: { message: data.message || data.alert || (this.esPdvSap ? 'El servidor devolvió un error al enviar a SAP.' : 'El servidor devolvió un error al cerrar el inventario.') } } }
        }
        openToast(this.esPdvSap ? 'Inventario enviado a SAP' : 'Inventario cerrado')
        await this.cargaInventarios()
      } catch (ex) {
        const msg = ex.response?.data?.message || ex.response?.data?.alert || (this.esPdvSap ? 'Error al enviar inventario a SAP' : 'Error al cerrar el inventario')
        openToast(msg)
        console.log(ex)
      } finally {
        this.loadingEnvioSap = false
        if (this.loadingEnvioSapKey === key) this.loadingEnvioSapKey = null
      }
    }
  },
  computed: {
    // totales agregados para el widget de resumen
    totalesGlobal () {
      const base = this.inventarios_filtrados && this.inventarios_filtrados.length ? this.inventarios_filtrados : this.resumenes
      const t = base.reduce((acc, r) => {
        acc.lineas += r.lineas || 0
        acc.pendientes += r.pendientes || 0
        acc.reabiertos += r.reabiertos || 0
        acc.aprobados += r.aprobados || 0
        acc.cerrados += r.cerrados || 0
        return acc
      }, { lineas: 0, pendientes: 0, reabiertos: 0, aprobados: 0, cerrados: 0 })
      // aproximamos reabierto como líneas tratadas aún no aprobadas
      t.reabierto = Math.max(0, (t.reabiertos || 0) - (t.aprobados || 0))
      return t
    },
    resumenes_base () {
      return this.inventarios_filtrados && this.inventarios_filtrados.length ? this.inventarios_filtrados : this.resumenes
    },
    resumenes_filtrados () {
      // aplicamos filtro por estado y texto de búsqueda
      let lista = this.resumenes_base
      if (this.filtro_estado) {
        lista = lista.filter(it => {
          if (this.filtro_estado === 'cerrado') return it.cerrados > 0 && it.cerrados >= it.lineas
          if (this.filtro_estado === 'listo') return it.pendientes === 0 && it.reabiertos >= it.lineas
          if (this.filtro_estado === 'reabierto') return it.pendientes === 0 && it.reabiertos > 0 && it.aprobados < it.reabiertos
          if (this.filtro_estado === 'pendientes') return it.pendientes > 0
          return true
        })
      }
      return lista
    }
  }
})
</script>

<style scoped>
.izquierda { text-align: left; }
.muy-grande { font-size: 1.4rem; }
.titulo { font-size: 1.2rem; font-weight: bold; margin-top: 10px; margin-bottom: 4px; }
.lote.oscuro { font-size: 0.9rem; color: var(--ion-color-medium); }
.lote.aviso { font-size: 0.9rem; color: var(--ion-color-warning); }
.lote.exito { font-size: 0.9rem; color: var(--ion-color-success); }
.lote.fracaso { font-size: 0.9rem; color: var(--ion-color-danger); }

#num-selected-items {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  font-size: 13px;
  border-radius: 5%;
  background: #3911c9;
  width: 16px;
  height: 16px;
  line-height:16px;
  display: block;
  text-align: center;
  color: white;
  font-family: 'Roboto', sans-serif;
  font-weight: bold;
}
.icon-filter { position: relative; top: 4px; z-index: 1; font-size: 24px; color: white; }
span.boton-opciones { font-size: larger !important; font-weight: bold !important; }

/* Estilos para sticky header del contador de pickings */
.pickings-counter-sticky {
  position: sticky;
  top: 0;
  z-index: 15;
  background-color: white;
  padding: 15px 70px;
  margin: 0;
  width: 100%;
}
.container-tablet { width: 100%; max-width: 768px; margin: 0 auto; scrollbar-width: none; }
</style>
